export default __webpack_public_path__ + "static/media/style-artisticStonelock.0a7c99b3.jpg";